/*
 * @file: constants.js
 * @description: It Contain action types Related Action.
 * @author: navreet
 */

/************ User *************/
export const public_type = 'public'
export const app_type = 'app'
export const private_type = 'private'
export const dashboard_path = 'dashboard'
export const app_path = 'app/faqs'
